import { DealFlag } from 'app/models/dto/team-deal';
import { AbstractCrudService } from 'app/services/abstract-crud/abstract-crud.service';
import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../http/clients/api';
import { environment } from 'environments/environment';

@Injectable()
export class DealFlagService extends AbstractCrudService<DealFlag> {
  baseUrl = `${environment.API_URL}/deal-flag`;

  constructor(
    private httpConcrete: ApiHttpClient
  ) {
    super(httpConcrete);
  }

  // Basic CRUD done in parent class. Add outlier stuff here if needed.
}
